import { useQuery } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { ThreadDetailParams, Thread } from './types'
import { getCleanThreadId } from '../views/AppNavigator/Messages/helpers'
import toast from 'react-hot-toast'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useThreadDetail = (params: ThreadDetailParams) => {
  const fetchWithAuth = useFetchWithAuth()

  const { thread_id, limit = 50, offset = 0 } = params

  return useQuery({
    queryKey: ['thread', thread_id, { limit, offset }],
    queryFn: async () => {
      try {
        const queryParams = new URLSearchParams()
        queryParams.append('limit', limit.toString())
        queryParams.append('offset', offset.toString())

        // Use clean thread ID for API call (removes #EVENT suffix)
        const cleanThreadId = getCleanThreadId(thread_id)
        const response = await fetchWithAuth(
          `${URL}/threads/${cleanThreadId}?${queryParams.toString()}`
        )

        return response as Thread
      } catch (error) {
        console.error(`Error fetching thread ${thread_id}:`, error)
        toast.error('Unable to load message thread. Please try again later.')
        throw error
      }
    },
    // Don't retry on server error to avoid spamming toast messages
    retry: (failureCount, error: any) => {
      if (error?.status === 500) return false
      return failureCount < 3
    },
    enabled: !!thread_id,
  })
}
